module.exports = __webpack_public_path__ + "static/media/library.4619000a.svg";